export const suklAdministrationRouteFrag = `
    id
    code
    name
`;
